import { z, zCalendarDate } from '@harvestiq/zod';

export const submitAgWorksLrpEndorsementPdfRequestBodySchema = z.object({
  SignedEndorsementsPDF: z
    .any()
    .refine((data) => data instanceof Buffer || data instanceof File, {
      message: 'SignedEndorsementsPDF must be a Buffer or File',
    }), // Not using z.instanceof(Buffer) due to common being used in both backend and frontend and Buffer is not available in frontend
  InsuredSignatureDate: zCalendarDate(),
  AgentSignatureDate: zCalendarDate(),
  PremiumLineOIDs: z.string(),
});

export type SubmitAgWorksLrpEndorsementPdfRequestBody = z.infer<
  typeof submitAgWorksLrpEndorsementPdfRequestBodySchema
>;

export const submitAgWorksLrpEndorsementPDFResponseSchema = z.object({
  requestTimestamp: z.string(),
  responseTimestamp: z.string(),
  message: z.string(),
  errors: z.array(z.string()),
  isValid: z.boolean(),
});

export type SubmitAgWorksLrpEndorsementPDFResponse = z.infer<
  typeof submitAgWorksLrpEndorsementPDFResponseSchema
>;
